import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useMobileLayout from 'Hooks/useMobileLayout';
import NewNavbar from 'Components/UI/Navigation/NewNavbar';
import Drawer from '@material-ui/core/Drawer';
import WizardNavigationContentWithContext
  from 'Components/ComponentLibrary/Organisms/Navigation/Container/Content/Navigations/WizardNavigation/WizardNavigationContentWithContext';
import { useNavigationContext } from 'Components/ComponentLibrary/Organisms/NavigationWithContext/NavigationContext';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import WizardNavigationContent
  from 'Components/ComponentLibrary/Organisms/Navigation/Container/Content/Navigations/WizardNavigation/WizardNavigationContent';

const styles = (theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    justifyContent: 'space-between',
  },
  drawerPaper: {
    width: '90%',
    minWidth: 320,
    maxWidth: 500,
    padding: theme.spacing(2.25),
    backgroundColor: theme.palette.facet.lightGray,
    display: 'flex',
    alignItems: 'flex-start',
  },
  content: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    flexGrow: 1,
    marginTop: theme.spacing(1),
  },
});


const WizardNavigation = ({
  className,
  classes,
  navigationCollection,
  open,
}) => {
  const isMobile = useMobileLayout();
  const resource = navigationCollection.resources().head();
  const { setOpen } = useNavigationContext();

  const closeDrawer = () => {
    setOpen(false);
  };

  if (isMobile) {
    return (
      <Drawer
        anchor="left"
        open={open}
        ModalProps={{ onBackdropClick: closeDrawer }}
        PaperProps={{ className: classes.drawerPaper }}
      >
        <IconButton onClick={closeDrawer} test="wizard-nav-close">
          <CloseIcon />
        </IconButton>
        <div className={classes.content}>
          <WizardNavigationContent isOpen resource={resource} />
        </div>
      </Drawer>
    );
  }

  return (
    <NewNavbar
      className={classNames(classes.root, className)}
      MenuButtonProps={{ test: 'wizard-navigation-menu-button' }}
    >
      <WizardNavigationContentWithContext resource={resource} />
    </NewNavbar>
  );
};

WizardNavigation.defaultProps = {
  className: '',
  open: false,
};

WizardNavigation.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  navigationCollection: PropTypes.object.isRequired,
  open: PropTypes.bool,
};

export default withStyles(styles)(WizardNavigation);
